define('casino/instantdeposit',['jquery', 'all/player/playerinfo', 'casino/info', 'casino/ingameFunctionalities', 'casino/game-mode', 'all/player/session', 'all/slidingContentWrapper', 'all/player/uk-deposittandc', 'all/paymentServices-toggles', 'payment/handlers/sendHandlers/sendHandlerController', 'boxes/events/paymentEvent'], function ($, playerinfo, casinoInfo, ingameFunctionalities, gameMode, session, slidingContentWrapper, UKDepositTandC, paymentServicesToggles, sendHandlerController, paymentEvent) {
    'use strict';

    var instantDeposit = window.instantdeposit = {};

    var latestInstantDepositInfo = null;
    var previousInstantDepositInfo = null;

    var amountEventName = 'blur';
    var cvcEventName = 'blur';

    var $instantDeposit = $('#instant-deposit-ingame');

    var listeners = [];

    function addListener(listener) {
        listeners.push(listener);
    }

    function notifyListeners(transactionStatusConst){
        for(var i = 0; i < listeners.length; i++) {
            listeners[i](transactionStatusConst);
        }
    }

    function instantDepositInit() {

		$(instantDeposit).on('RESET', function (event) {
			event.preventDefault();
			instantDepositInit();
		});

       	$(instantDeposit).on(paymentEvent.SUCCESSFUL_TRANSACTION_COMPLETED, function (event, paymentResultData) {
			event.preventDefault();

			stopPaymentLoadingAnimationIfVisible();

			notifyListeners("2");

			$('#amount_deposited').text(paymentResultData.amount);

			// TODO: Add fee and totalDebited to PaymentFormDataServivce getDepositResult
			$('#deposit_fee').text(paymentResultData.fee);
			$('#total_debited').text(paymentResultData.debitedAmount);

			setInstantDepositModePaymentSucceeded();

		});

		$(instantDeposit).on(paymentEvent.TRANSACTION_FAILED, function (event) {
			event.preventDefault();

			notifyListeners("1");

			stopPaymentLoadingAnimationIfVisible();
			setInstantDepositModePaymentFailed();

		});

			addClick($('#contract_instant_deposit'), contractInstantDeposit);
        addClick($('#expand_instant_deposit'), expandInstantDeposit);
        addClick($('#make_deposit'), makeDeposit);
        addClick($('#close_successful'), closeSuccessfulResponse);
        addClick($('#try_again'), tryAgain);
        addClick($('#try_another_card_or_method'), tryAnotherCardOrMethod);

        addEvent($('#amuntfield'), amountEventName, validateAmount);
        addEvent($('#cvcfield'), cvcEventName, validateCvc);

        setInstantDepositModeInvisible();
        if (typeof playerinfo.info === 'undefined') {
            latestInstantDepositInfo = null;
        } else {
            loadInstantDepositJson(setInstantDepositModeDeposit);
        }
    }

    function tryAnotherCardOrMethod() {
        slidingContentWrapper.showSlidingInstantDeposit(getAmount());
        setInstantDepositModeDeposit();
    }

    function validateCvc(event) {
        event.preventDefault();
        var cvcIsValid = validateInput('cvcfield', /\d{3}$/);
        setFieldValidationClass($('#cvc'), !cvcIsValid);
    }

    function validateInput(id, pattern) {
        var input = $('#' + id).val();
        if (pattern.test(input)) {
            // ok
            return true;
        } else {
            // error
            return false;
        }
    }

    function validateAmount(event) {

        event.preventDefault();

        var amount = getAmount();

        if (latestInstantDepositInfo !== null && amount > 0) {
            //TODO change it to GetPaymentSummary flow

			var method = latestInstantDepositInfo.paymentMethodString;

			var feeLimitUrl = '/PaymentFormDataService/getDepositFeesAndLimits';

			if (latestInstantDepositInfo.paymentMethodIsCard) {
				feeLimitUrl = '/CreditCardIntegration/getCreditCardDepositFeesAndLimits';
				method = "1";
			}

            $.get(feeLimitUrl, $.param({
				method: method,
                    currency: latestInstantDepositInfo.depositCurrencyCode,
                    amount: amount,
                    cid: latestInstantDepositInfo.playerCardId,
                    INSTANT_DEPOSIT: 'true',
					isMobileDevice: 'false'
                })
            ).done(function (data) {

                    var showError = false;

                    if (data.RESULT === 'OK') {

                        var amount = getAmount();
						var depositLimitData = data.depositLimitData;
						var max = parseFloat(depositLimitData.PARAM_MAX_OPERATION);
						var min = parseFloat(depositLimitData.PARAM_MIN_OPERATION);
						var RGLimit = parseFloat(depositLimitData.PARAM_RESPONSIBLE_GAMING_LIMIT);

                        if (RGLimit !== null && max !== null && RGLimit > 0 && max < min) {
                            // still has (RGLimit - max) money to play, but the max cannot be less than the min amount of money
                            showError = true;
						}

                        if (amount < min || amount > max) {
                            showError = true;
                        }

                        setFieldValidationClass($('#amount'), showError);
                    }

                }).fail(function (data) {
                    console.error('validateAmount fail, data: ' + data);
                    setFieldValidationClass($('#amount'), true);
                });
        } else {
            setFieldValidationClass($('#amount'), true);
        }
    }

    function setFieldValidationClass($selector, showError) {
        var validationClass = getValidationClass(showError);
        $selector.attr('class', validationClass);
    }

    function setNotValidated($selector) {
        var validationClass = 'field';
        $selector.attr('class', validationClass);
    }

    function getValidationClass(showError) {
        var validationClass = 'field valid';
        if (showError) {
            validationClass = 'field error';
        }
        return validationClass;
    }

    function isFieldValidatedOk(id) {
        var validationClassOk = getValidationClass(false);
        var $selector = $('#' + id);
        if ($selector.attr('class') === validationClassOk) {
            return true;
        } else {
            return false;
        }
    }

    function getAmount() {
        var amount = parseFloat($('#amuntfield').val());
        if (isNaN(amount)) {
            amount = 0;
        }
        return amount;
    }

    function closeSuccessfulResponse() {
        setInstantDepositModeDeposit();
    }

    function tryAgain() {
        // Try again means we have failed earlier, and we might need to know about new failed transactions that makes us use another provider
        loadInstantDepositJson();
        setInstantDepositModeDeposit();
    }

    function addClick($selector, clickCallback) {
        addEvent($selector, 'click', clickCallback);
    }

    function addEvent($selector, event, clickCallback) {
        $selector.off(event);
        $selector.on(event, clickCallback);
    }

    function triggerValidateAmountIfNotValidated() {
        if (!isFieldValidatedOk('amount')) {
            $('#amuntfield').trigger(amountEventName);
        }
    }

    function triggerValidateCvc() {
        $('#cvcfield').trigger(cvcEventName);
    }

    function makeDeposit() {
        if (latestInstantDepositInfo !== null) {
            // Do actual deposit
            triggerValidateAmountIfNotValidated();
            if (latestInstantDepositInfo.lastDepositMethodWasCreditCard) {
                triggerValidateCvc();
                if (isFieldValidatedOk('amount') && isFieldValidatedOk('cvc')) {
                    ////Deposit popup for UK terms
                    if(getUKInstantDepositTandCStatus() === true) {
                        // Send cc deposit
                        instantDepositSendCcDeposit();
                    }
                }
            } else {
                // Open quick deposit if amount is valid, we could actually open quick deposit even if amount is not valid but...
                if (isFieldValidatedOk('amount')) {
					slidingContentWrapper.showSlidingInstantDeposit(getAmount());
                }
            }
        }
    }

    function getUKInstantDepositTandCStatus(){
        var ukInstantDepositTandCStatusResponse = null;
        UKDepositTandC.verifyUKDepositTandCStatus(function(response){
            ukInstantDepositTandCStatusResponse = response;
        });
        if(ukInstantDepositTandCStatusResponse.RESULT !== 'OK'){
            showUKInstantDepositTandCPopup(ukInstantDepositTandCStatusResponse);
        }else{
            return true;
        }
    }

    function showUKInstantDepositTandCPopup(ukInstantDepositTandCStatusResponse) {
        var data = {
            heading: ukInstantDepositTandCStatusResponse.UK_DEPOSIT_TERMS_UPDATED_HEADER,
            message: ukInstantDepositTandCStatusResponse.UK_DEPOSIT_TERMS_UPDATED,
            confirm: ukInstantDepositTandCStatusResponse.AGREE
        };
        dialog.load('UKInstantDepositTandC', data, undefined, undefined);
    }

    function updateUKTandCandFinalizeInstantDeposit(){
        var ukInstantDepositTandCUpdateResponse = null;
        UKDepositTandC.updateUKTandCForDeposit(function(response){
            ukInstantDepositTandCUpdateResponse = response;
        });
        dialog.close('UKInstantDepositTandC');
        if(ukInstantDepositTandCUpdateResponse.RESULT === 'OK'){
            instantDepositSendCcDeposit();
        }
    }


	function instantDepositSendCcDeposit() {

        setInstantDepositModePaymentOngoing();


		var parameters = {
			am: getAmount(),
			cuid: latestInstantDepositInfo.depositCurrencyCode,
			cc: $('#cvcfield').val(),
			cid: latestInstantDepositInfo.playerCardId,
			co: latestInstantDepositInfo.cardOwner,
			vy: latestInstantDepositInfo.validYear,
			vm: latestInstantDepositInfo.validMonth,
			utimestamp: (new Date().getTime()),
			instantDeposit: 'true',
			isMobileDevice: 'false'
		};

		var contentType = 'application/json; charset=utf-8';
		parameters = JSON.stringify(parameters);


		$.ajax ({
			url: '/CreditCardIntegration/executeDeposit',
			type: 'POST',
			data: parameters,
			dataType: 'json',
			contentType: contentType,
			success: function (responseData) {
				if (responseData.successful === true) {
					sendHandlerController.handleSuccessfulResponse(undefined, responseData.sendHandlerData, responseData.accHistRef, responseData.paymentFetchResultFlow);
				} else {
					console.error('sendDeposit failed, data: ' + responseData);
					setInstantDepositModePaymentFailed();
				}
			}
		});

    }

	// setModeFromInstantDepositDepositInfo() might in theory still be used by old mobile angular app in 3ds redirect back pages
    function setModeFromInstantDepositDepositInfo(instantDepositDepositInfo) {

        if (instantDepositDepositInfo !== null) {
            notifyListeners(instantDepositDepositInfo.transactionStatusConst);
            if (instantDepositDepositInfo.transactionStatusConst === 2) {
                updatePaymentSucceeded(instantDepositDepositInfo);
                setInstantDepositModePaymentSucceeded();
            } else {
                setInstantDepositModePaymentFailed();
            }
        } else {
            notifyListeners(1);
            setInstantDepositModePaymentFailed();
        }
    }

    function updatePaymentSucceeded(instantDepositDepositInfo) {
        $('#amount_deposited').text(instantDepositDepositInfo.amount);
        $('#deposit_fee').text(instantDepositDepositInfo.fee);
        $('#total_debited').text(instantDepositDepositInfo.totalDebited);
    }

    function doesDialogInfoExistsInResponse(jsonData) {
        if (jsonData === null || jsonData === undefined) {
            return false;
        } else {
            var systemError = jsonData.RESULT === 'SYSTEM_ERROR';
            var infoPopup = jsonData.RESULT === 'INFO_POPUP';
            var confirmPopup = jsonData.RESULT === 'CONFIRM_POPUP';
            return (systemError || infoPopup || confirmPopup);
        }
    }

    function updateInstantDepositInfo() {

        $('#payment_method_logo').attr('src', latestInstantDepositInfo.methodLogoPath);
        $('#amuntfield').val(latestInstantDepositInfo.depositAmount);
        $('#cardnumberfield').text(latestInstantDepositInfo.cardNumberSimpleMasked);
        $('#currency_symbol').text(latestInstantDepositInfo.depositCurrencySymbol);

        if (latestInstantDepositInfo.lastDepositMethodWasCreditCard) {
            $('#card').show();
            $('#cvc').show();
        } else {
            $('#card').hide();
            $('#cvc').hide();
        }

        if (getAmount() > 0) {
            triggerValidateAmountIfNotValidated();
        } else {
            setNotValidated($('#amount'));
        }

        if (!(previousInstantDepositInfo !== null && latestInstantDepositInfo.playerCardId !== null &&
            previousInstantDepositInfo.playerCardId === latestInstantDepositInfo.playerCardId)) {
            $('#cvcfield').val('');
            setNotValidated($('#cvc'));

        } //else {
            // Let cvc stay in the form untouched since it is the same card
        //}
    }

    function setInstantDepositModeInvisible() {
        $('#instant-deposit-ingame').hide();
    }

    function showInstantDepositInGameAndExpand() {
        if (gameMode.getGameMode() === gameMode.MODE_ONE_GAME) {
            var $instantDepositElement = $('#instant-deposit-ingame');
            if (ingameFunctionalities.isFeedMaximumSize()) {
                $instantDepositElement.addClass('expanded');
            } else if (ingameFunctionalities.isFeedMediumSize()) {
                $instantDepositElement.addClass('expanded');
                $instantDepositElement.addClass('compact');
            }
            else {
                $instantDepositElement.addClass('expanded');
                $instantDepositElement.removeClass('compact');
            }
            $instantDepositElement.css('display','block');
        }
    }

    function setInstantDepositModeDeposit() {
        $('#instant_deposit').show();
        $('#payment_accepted').hide();
        $('#payment_failed').hide();
        $('#payment_loader').hide();
        showInstantDepositInGameAndExpand();
    }

    function setInstantDepositModePaymentSucceeded() {
        $('#instant_deposit').hide();
        $('#payment_accepted').show();
        $('#payment_failed').hide();
        $('#payment_loader').hide();
    }

    function setInstantDepositModePaymentFailed() {
        $('#instant_deposit').hide();
        $('#payment_accepted').hide();
        $('#payment_failed').show();
        $('#payment_loader').hide();
    }

    function setInstantDepositModePaymentOngoing() {
        $('#instant_deposit').hide();
        $('#payment_accepted').hide();
        $('#payment_failed').hide();
        $('#payment_loader').show();
    }

    function stopPaymentLoadingAnimationIfVisible() {
        if ($('#payment_loader').is(':visible')) {
            // Go back to deposit state where it came from
            setInstantDepositModeDeposit();
        }
    }

    function contractInstantDeposit(event) {
        event.preventDefault();
        if (ingameFunctionalities.isGameLoaded() || ingameFunctionalities.isGroupLoaded()) {
            $instantDeposit.removeClass('expanded');
            if ($instantDeposit.hasClass('compact')) {
                $instantDeposit.removeClass('compact');
            }
            if (sessionStorage.getItem('resizedGame') === 'true') {
                $('#contract_activity_feed').trigger('click');
            }
        } else {
            $instantDeposit.removeClass('expanded');
            if ($instantDeposit.hasClass('compact')) {
                $instantDeposit.removeClass('compact');
            }
        }
    }

    function expandInstantDeposit(event) {
        if (ingameFunctionalities.isGameLoaded() || ingameFunctionalities.isGroupLoaded()) {
            event.preventDefault();
            if (gameMode.getGameMode() === gameMode.MODE_ONE_GAME) {
                $instantDeposit.addClass('expanded');
                resizeDepositBasedOnScreenResolutionAndGameSize();
            }  else {
                $instantDeposit.removeClass('expanded');
                $instantDeposit.removeClass('compact');
            }
        }
    }

    function resizeDepositWhenWinnersFeedEmpty() {
        if(gameMode.getGameMode()!== gameMode.MODE_ONE_GAME){
            setInstantDepositModeInvisible();
            return;
        }

        if (ingameFunctionalities.isAllowedToAddMaximumFeedAndDeposit()) {
            changeInstantDepositToMaximizedWidth();
        } else if (ingameFunctionalities.isAllowedToAddCompactFeedAndDeposit()) {
            changeInstantDepositToCompactWidth();
        } else {
            changeInstantDepositToMinimizedWidth();
        }
    }

    function resizeDepositBasedOnScreenResolutionAndGameSize() {
        if (ingameFunctionalities.isAllowedToAddMaximumFeedAndDeposit()) {
            return;
        } else if (ingameFunctionalities.isAllowedToAddCompactFeedAndDeposit()) {
            $instantDeposit.addClass('compact');
        } else {
            $instantDeposit.addClass('compact');
            if (ingameFunctionalities.isFeedIcon()) {
                $('#expand_activity_feed').trigger('click');
            }
        }
    }

    function getInstantDepositInfoJsonFromServer(waitmilliseconds) {
        setTimeout(function () {
            loadInstantDepositJson();
        }, waitmilliseconds);
    }

    function loadInstantDepositJson(callback) {
		var url = '/PaymentFormDataService/getInstantDepositInfo'; // '/PaymentFormDataService/getInstantDepositInfo' or '/pp?flow=GetInstantDepositInfoJson'
		$.post(url, {isMobileDevice: false})
            .done(function (data) {
                previousInstantDepositInfo = latestInstantDepositInfo;
                latestInstantDepositInfo = data;
                updateInstantDepositInfo();
                if ($.isFunction(callback)) {
                    callback(data);
                }
            })
            .fail(function (data) {
                console.error('getInstantDepositInfoJsonFromServer failed, data: ' + data);
            });
    }

    function isInstantHidden() {
        if ($instantDeposit.css('display') === 'none') {
            return true;
        }
        return false;
    }

    function isInstantDepositCompact() {
        if ($instantDeposit.hasClass('compact') &&  $instantDeposit.css('display')!=='none') {
            return true;
        }
        return false;
    }

    function isInstantDepositMaximized() {
        if ($instantDeposit.hasClass('expanded') && !$instantDeposit.hasClass('compact')) {
            if ($instantDeposit.css('display') !== 'none') {
                return true;
            }
        }
        return false;
    }

    function isInstantDepositMinimized() {
        if (!$instantDeposit.hasClass('expanded') && $instantDeposit.css('display') !== 'none') {
            return true;
        }
        return false;
    }

    function transformInstantDepositFromMaximizedToCompact() {
        $('#instant-deposit-ingame').addClass('compact');
    }

    function transformInstantDepositFromCompactToMaximized() {
        $('#instant-deposit-ingame').removeClass('compact');
    }

    function transformInstantDepositFromMinimizedToCompact() {
        var $instantDepositElement=$('#instant-deposit-ingame');
        if ($instantDepositElement.hasClass('compact')) {
            $instantDepositElement.addClass('expanded');
        } else if (!$instantDepositElement.hasClass('compact')) {
            $instantDepositElement.addClass('expanded');
            $instantDepositElement.addClass('compact');
        }
    }


    function changeInstantDepositToMaximizedWidth() {
        var $instantDepositElement=$('#instant-deposit-ingame');
        if (!session.authenticated) {
            return;
        }
        if (isInstantDepositMaximized()) {
            return;
        } else if (isInstantDepositMinimized()) {
            if (gameMode.getGameMode() === gameMode.MODE_ONE_GAME) {
                $('#expand_instant_deposit').trigger('click');
                $instantDepositElement.css('display', 'block');
            } else if (gameMode.getGameMode() === gameMode.MODE_FOUR_GAMES) {
                $instantDepositElement.addClass('expanded');
            }
        } else if (isInstantDepositCompact()) {
            transformInstantDepositFromCompactToMaximized();
        } else if (isInstantHidden()) {
            $instantDepositElement.css('display', 'block');
            $instantDepositElement.addClass('expanded');
            $instantDepositElement.removeClass('compact');
        }
    }

    function changeInstantDepositToCompactWidth() {
        var $instantDepositElement=$('#instant-deposit-ingame');
        if (!session.authenticated) {
            return;
        }
        if (isInstantDepositCompact()) {
            return;
        } else if (isInstantDepositMinimized()) {
            transformInstantDepositFromMinimizedToCompact();
        } else if (isInstantDepositMaximized()) {
            transformInstantDepositFromMaximizedToCompact();
        } else {
            $instantDepositElement.addClass('compact');
            $instantDepositElement.addClass('expanded');
            $instantDepositElement.css('display', 'block');
        }
    }

    function changeInstantDepositToMinimizedWidth() {
        if (!session.authenticated) {
            return;
        }
        if (isInstantDepositMaximized()) {
            $('#contract_instant_deposit').trigger('click');
        } else if (isInstantDepositMinimized()) {
            return;
        } else if (isInstantDepositCompact()) {
            $('#contract_instant_deposit').trigger('click');
        }else if(isInstantHidden()){
            $instantDeposit.removeClass('expanded');
            $instantDeposit.removeClass('compact');
            $instantDeposit.css('display','block');
        }
    }

    instantDeposit.instantDepositInit = instantDepositInit;
    instantDeposit.addListener = addListener;
    instantDeposit.setModeFromInstantDepositDepositInfo = setModeFromInstantDepositDepositInfo;
    instantDeposit.getInstantDepositInfoJsonFromServer = getInstantDepositInfoJsonFromServer;
    instantDeposit.getAmount = getAmount;
    instantDeposit.setInstantDepositModeInvisible = setInstantDepositModeInvisible;
    instantDeposit.changeInstantDepositToMaximizedWidth = changeInstantDepositToMaximizedWidth;
    instantDeposit.changeInstantDepositToCompactWidth = changeInstantDepositToCompactWidth;
    instantDeposit.changeInstantDepositToMinimizedWidth = changeInstantDepositToMinimizedWidth;
    instantDeposit.isInstantDepositMinimized = isInstantDepositMinimized;
    instantDeposit.isInstantDepositMaximized = isInstantDepositMaximized;
    instantDeposit.isInstantDepositCompact = isInstantDepositCompact;
    instantDeposit.resizeDepositWhenWinnersFeedEmpty = resizeDepositWhenWinnersFeedEmpty;
    instantDeposit.updateUKTandCandFinalizeInstantDeposit = updateUKTandCandFinalizeInstantDeposit;
    return instantDeposit;
})
;

